import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { SharedUpdateService } from './update.service';

@Component({
	moduleId: module.id,
	selector: 'base-child-dialog',
	template: ''
})

export class BaseChildDialog implements OnInit, OnDestroy {

	protected _subscriptions$: Subject<boolean>;
	public nInWater: number;

	constructor(
		private _dialogRef: MatDialogRef<BaseChildDialog>,
		private _sharedUpdateService: SharedUpdateService,
	) {
	}

	ngOnInit(): void {

		this._subscriptions$ = new Subject();
		this._configureClickOutside(this._subscriptions$);
	}

	ngOnDestroy(): void {

		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public onClose(): void {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}

	private _configureClickOutside(s: Subject<boolean>): void {
		// custom click outside behavior
		this._dialogRef.disableClose = true;

		this._dialogRef.backdropClick().pipe(takeUntil(s)).subscribe(() => {
			this.onClose();
		});
	}
}
